import React from 'react';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import { Row, Col, Space, Divider, Popover } from 'antd';
import { getChildrenToRender } from './utils';
import { isImg } from './utils';
import { FooterDataSource }  from './data.js';
import { Footer as ANTFooter } from 'antd-mobile';
class Footer extends React.Component {
  static defaultProps = {
    className: 'footer',
  };

  getLiChildren = (data) =>
    data.map((item, i) => {
      const { title, childWrapper, ...itemProps } = item;
      return (
        <Col key={i.toString()} {...itemProps} title={null} content={null}>
          <h2 {...title}>
            {typeof title.children === 'string' &&
              title.children.match(isImg) ? (
                <img alt="apexDB product FEATURES" src={title.children} width="100%" />
            ) : (
              title.children
            )}
          </h2>
          <div {...childWrapper}>
            {childWrapper.children.map(getChildrenToRender)}
          </div>
          {childWrapper.extra && <Popover placement='right'  content={<img alt="apexDB contact us" width={80} src={childWrapper.extra.hoverImg }></img>} title="" trigger="hover">
            <img alt="apexDB contact us" style={{opacity:'0.6'}} width={40} src={childWrapper.extra.smallImg }></img>
          </Popover> }
        </Col>
      );
    });


  renderPC = (props) => {
    const childrenToRender = this.getLiChildren(FooterDataSource.block.children);

    return (
      <div {...props} {...FooterDataSource.wrapper}>
        <OverPack {...FooterDataSource.OverPack}>
          <QueueAnim
            type="bottom"
            key="ul"
            leaveReverse
            component={Row}
            {...FooterDataSource.block}
          >
            {childrenToRender}
          </QueueAnim>
          <TweenOne
            animation={{ y: '+=30', opacity: 0, type: 'from' }}
            key="link"
            className={'footer-link'}
          >
            <Row className='footer-link-wrapper'>
              <Col span={2} className='footer-link-wrapper-title'>
                {FooterDataSource.link.title}
              </Col>
              <Col span={22}>
                <Space split={<Divider type="vertical" className='footer-link-divider' />} size={8} align="center" >
                  {FooterDataSource.link.children.map(item => (<a {...item}>{item.children}</a>))}
                </Space>
              </Col>

            </Row>

          </TweenOne>
          <TweenOne
            animation={{ y: '+=30', opacity: 0, type: 'from' }}
            key="copyright"
            {...FooterDataSource.copyrightWrapper}
          >
            <div {...FooterDataSource.copyrightPage}>
              <div {...FooterDataSource.copyright}>
                {FooterDataSource.copyright.children}
              </div>
            </div>
          </TweenOne>
        </OverPack>
      </div>
    );
  }
  renderMobile = (props) => {
    const mobile = FooterDataSource.mobile;

    return (
      <div {...props} {...FooterDataSource.wrapper}>
        <div className={'footer-content'}>
          <h3>{mobile.title}</h3>


          <Space direction="vertical" size={[10, 8]}>
            <div>
              <span style={{marginRight:'10px'}}>{mobile.subTitle}</span>
              <Popover placement='right' content={<img alt="apexDB contact us" width={80} src={mobile.icon.hoverImg}></img>} title="" trigger="hover">
                <img alt="apexDB contact us" style={{ opacity: '0.6' }} width={20} src={mobile.icon.smallImg}></img>
              </Popover>
            </div>
            {mobile.children.map(item => (<div>{item.children}</div>))}
          </Space>
          <div className="footer-btn" onClick={e => {
            window.location.href = `tel:${mobile.btn.tel}`
          }}>{mobile.btn.title}: {mobile.btn.tel }</div>
          <div className='footer-copyright' >{mobile.copyright}</div>
        </div>

        </div>)
  }

  render() {
    const { ...props } = this.props;
    const { isMobile } = props;
    return isMobile ? this.renderMobile(props) : this.renderPC(props);
  }
}

export default Footer;
